exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  border-bottom: #ff404e 2px solid;\n  opacity: 0.95; }\n  .navbar .nav-item.active {\n    border-left: #ff404e 0.8px solid; }\n    .navbar .nav-item.active .nav-link {\n      color: #ff404e; }\n  .navbar .navbar-brand {\n    color: white; }\n  .navbar .navbar-toggler {\n    border: 1px #ff404e solid; }\n    .navbar .navbar-toggler .navbar-toggler-icon {\n      background-color: #CCC; }\n  .navbar .nav-link {\n    color: white;\n    font-size: 19px;\n    padding-left: 1em;\n    padding-right: 1em; }\n    .navbar .nav-link:hover {\n      color: #ff404e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/navbar/navbar.component.scss
// module id = ../../../../../src/app/pages/navbar/navbar.component.scss
// module chunks = main